module.exports = __webpack_public_path__ + "img/upload-id.a990660a.jpg";